module.exports = __webpack_public_path__ + "img/monitor.6b19a1bd.svg";